<!--
  - 导航快速跳转组件
-->

<template>
  <div class="items">
    <Tabs>
      <TabPane :key="key" v-for="(item,key) in group" :label="item.type">
        <div class="per-item" v-for="per in item.list" @click="$emit('click', per)">
          <div class="bl-icon">
            <svg width="25%" :class="per.class" aria-hidden="true">
              <use :xlink:href="per.icon"></use>
            </svg>
          </div>
          <div class="bl-desc">
            {{per.title}}
          </div>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>


  export default {
    name: 'items',
    data(){
      return {}
    },
    props: [
      'group'
    ],
    created(){
      this.$wow_init();
    },
    methods: {
    }
  }
</script>

<style scoped lang="less">
  .items {
    .ivu-tabs {
      width: 100%;
    }

    .ivu-tabs-tabpane {
      flex-direction: row;
      display: flex;
    }

    .per-item {
      display: flex;
      flex-direction: column;
      transition: box-shadow 0.3s;
      cursor: pointer;

      .bl-icon {
        display: flex;
        flex: 1;
        justify-content: center;
        transition: 0.5s;
        //语言配色
        .icon-php {
          color: #6B7EB7;
        }

        .icon-python {
          color: #366C9B;
        }

        .icon-nodejs {
          color: #8FC740;
        }

        .icon-perl {
          color: #2173D6;
        }

        .icon-java {
          color: #1955A2;
        }

        .icon-ruby {
          color: #C3251F;
        }
      }

      .bl-desc {
        display: flex;
        justify-content: center;
        flex: 1;
        font-size: 15px;
        font-weight: bold;
      }

    }

    .per-item:hover {
      .bl-icon {
        transform: translateY(-5px);
      }
    }
  }
</style>
